import { render, staticRenderFns } from "./projects-preview.vue?vue&type=template&id=511b72f0&"
import script from "./projects-preview.vue?vue&type=script&lang=js&"
export * from "./projects-preview.vue?vue&type=script&lang=js&"
import style0 from "./projects-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports